/* eslint-disable */
import services from 'services';
import store from '@/store';

const _ = require('lodash');

export default {
  /**
   * Applied as a middleware before a root is executed.
   * @method guardRoute
   * @param  {Object}   to     the next route object
   * @param  {Object}   from   the current route object
   * @param  {Function} next   callback used by vue-router
   * @return {void}
   */
  async guardRoute(to, from, next) {
    const auth = store.getters['auth/isAuthenticated'];
    const shopAuth = await store.dispatch('shopAuth/fetchState');
    let isAuthenticated = true;
    if (!auth) {
      isAuthenticated = services.AuthStateListener.listenUserState()
        .then((res) => !!res)
        .catch(() => false);
    }

    Promise.resolve(isAuthenticated)
      .then((isAuth) => {
        // route requires auth
        if (_.get(to, 'meta.shopAuth') === true && !shopAuth) {
          return next({ name: 'Welcoming' });
        } else if (_.get(to, 'meta.auth') === true && !isAuth) {
          return next({ name: 'Login' });
        } else if (_.get(to, 'meta.guestOnly') === true && isAuth) {
          return next({ name: 'Dashboard' });
        }
        return next();
      });
  },
};
